import styled from 'styled-components';
import { SpinnerStyled } from '../SpinnerStyled';

export const SpinnerStyledAC = styled(SpinnerStyled)``;
